export const STATUS_LABELS = {
  todo: "To Do",
  in_progress: "In Progress",
  review: "Review",
  done: "Completed",
};

export const STATUS_COLORS = {
  todo: { bg: "#F1F5F9", fg: "#64748B" },
  in_progress: { bg: "#DBEAFE", fg: "#1D4ED8" },
  review: { bg: "#EDE9FE", fg: "#7C3AED" },
  done: { bg: "#D1FAE5", fg: "#047857" },
};

export const PRIORITY_LABELS = { low: "Low", normal: "Medium", high: "High", urgent: "Urgent" };

export const PRIORITY_COLORS = {
  low: "#94A3B8",
  normal: "#3B82F6",
  high: "#F59E0B",
  urgent: "#EF4444",
};

export const FUNCTIONAL_DEPARTMENTS = [
  "video", "design", "content", "social_media", "seo", "web_dev",
];

export const FUNCTIONAL_ROLE_LABELS = {
  video: "Video",
  design: "Design",
  content: "Content",
  social_media: "Social Media",
  seo: "SEO",
  web_dev: "Web Development",
};

export const FUNCTIONAL_ROLE_COLORS = {
  video: "#A855F7",
  design: "#EC4899",
  content: "#F59E0B",
  social_media: "#0EA5E9",
  seo: "#10B981",
  web_dev: "#6366F1",
};

export const TASK_STATUSES = ["todo", "in_progress", "review", "done"];
export const TASK_PRIORITIES = ["low", "normal", "high", "urgent"];
